import { render, staticRenderFns } from "./SimilarArticle.vue?vue&type=template&id=1a1e9b0a&scoped=true&"
import script from "./SimilarArticle.vue?vue&type=script&lang=js&"
export * from "./SimilarArticle.vue?vue&type=script&lang=js&"
import style0 from "./SimilarArticle.vue?vue&type=style&index=0&id=1a1e9b0a&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1e9b0a",
  null
  
)

export default component.exports